module.exports = __webpack_public_path__ + "static/media/country_ps.1a54b5fe.webp";